<router-outlet *ngIf="phasesCheckDone" [dir]="dir"></router-outlet>
